import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';

interface CourseNavButtonProps {
  title: string;
  subtitle?: string;
  selected: boolean;
  complete: boolean;
  disabled: boolean;
  mobileSize: boolean;
  onClick: () => void;
}

const CourseNavButton = (props: CourseNavButtonProps) => {
  const theme = useTheme();

  return (
    <Tooltip
      arrow
      title={
        props.disabled ? 'Complete previous modules first' : 'Navigate here'
      }
    >
      <Box
        onClick={() => !props.disabled && props.onClick()}
        display="flex"
        alignItems="center"
        sx={{
          cursor: props.disabled ? 'help' : 'pointer',
          opacity: props.disabled ? '.5' : '1',
          borderRadius: '.25em',
          paddingX: '1em',
          paddingY: '.5em',
          minHeight: props.mobileSize ? '5em' : undefined,
          borderStyle: 'solid',
          borderWidth: '.1em',
          borderColor: props.selected
            ? theme.palette.text.primary
            : // We use a transparent border when not selected so that the sizing stays consistent
              //  between the selected course components and the unselected course components
              'transparent',
          '&:hover': {
            backgroundColor:
              theme.palette.mode == 'light' ? '#0000000a' : '#ffffff0a',
          },
        }}
      >
        <Box width="100%">
          <Typography fontSize="1.1em" fontWeight={600}>
            {props.title}
          </Typography>
          {props.subtitle && (
            <Typography
              color={theme.palette.text.secondary}
              fontSize=".8em"
              fontWeight={600}
            >
              {props.subtitle}
            </Typography>
          )}
        </Box>
        {props.complete ? (
          <CheckBoxRoundedIcon color="success" />
        ) : (
          <CheckBoxOutlineBlankRoundedIcon />
        )}
      </Box>
    </Tooltip>
  );
};

export default CourseNavButton;
